import axios from 'axios';

import {
  GET_GIFT_INFORMATIONS_REQUEST,
  GET_GIFT_INFORMATIONS_SUCCESS,
  GET_GIFT_INFORMATIONS_FAILURE,
  GET_CITIES_TEAMS_REQUEST,
  GET_CITIES_TEAMS_SUCCESS,
  GET_CITIES_TEAMS_FAILURE,
  GET_GIFT_AGREEMENT_REQUEST,
  GET_GIFT_AGREEMENT_SUCCESS,
  GET_GIFT_AGREEMENT_FAILURE,
  UPDATE_GIFT_INFORMATIONS_REQUEST,
  UPDATE_GIFT_INFORMATIONS_SUCCESS,
  UPDATE_GIFT_INFORMATIONS_FAILURE
} from 'Store/constants';

import { openModal } from './modalActions';

import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;


export const getGiftInformations = () => async dispatch => {
  try {
    dispatch({
      type: GET_GIFT_INFORMATIONS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/user-settings/gift-information`);

    dispatch({
      type: GET_GIFT_INFORMATIONS_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_GIFT_INFORMATIONS_FAILURE,
      payload: errorMessage
    });
  }
};

export const getCitiesTeams = () => async dispatch => {
  try {
    dispatch({
      type: GET_CITIES_TEAMS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/cms/userOptions/teams-cities`);

    dispatch({
      type: GET_CITIES_TEAMS_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_CITIES_TEAMS_FAILURE,
      payload: errorMessage
    });
  }
};

export const getGiftAgreement = () => async dispatch => {
  try {
    dispatch({
      type: GET_GIFT_AGREEMENT_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/cms/userAgreement/latestGiftInfoAgreement`);

    dispatch({
      type: GET_GIFT_AGREEMENT_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_GIFT_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const updateGiftInformations = formData => async dispatch => {
  
  try {
    dispatch({
      type: UPDATE_GIFT_INFORMATIONS_REQUEST
    });

    const res = await axios.put(`${API_GATEWAY}/user-settings/gift-information`, formData);

    dispatch({
      type: UPDATE_GIFT_INFORMATIONS_SUCCESS,
      payload: res?.data
    });
    dispatch(openModal('updateGiftInformationsSuccessModal'));

  } catch (e) {

    dispatch({
      type: UPDATE_GIFT_INFORMATIONS_FAILURE,
      payload: errorMessage
    });
  }
};
